export enum BodyMapEntryStatusEnums {
  ONGOING = "ongoing",
  RESOLVED = "resolved",
}
